import { Component, OnInit } from '@angular/core';
import { MyOverlayRef } from 'src/app/shared/services/overlay/overlay-ref';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
})
export class DeletePopupComponent {
  constructor(public ref: MyOverlayRef) {}

  close(isDeleted?: boolean) {
    this.ref.close(isDeleted);
  }
}
